import { useEffect, useRef, useState } from "react";

const useIsOverflowing = (ref) => {
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (ref.current) {
                setIsOverflowing(
                    ref.current.scrollHeight > ref.current.clientHeight ||
                    ref.current.scrollWidth > ref.current.clientWidth
                );
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, [ref]);

    return isOverflowing;
};
export default useIsOverflowing;